<template lang="pug">
#work.container-fluid
  #Header.row.valign-wrapper
    .col.s12.center
      br
      img#mainLogo(src="../assets/desktop/landing/2024/Desktop_HomePage_Logo.png")
  #content.relative.center
    .row(v-for="p in infoProjects[project]")
      p.Fjalla.normalSize {{p.Title}}
      br
      .row(v-for="c in p.content")
        div(v-if="c.type=='video'")
          iframe.youtube(:src="c.url" frameborder="0" allowfullscreen)
        div(v-if="c.type=='slides'")
          .slides
            img(v-for="(s, i) in c.pictures" :src="s" v-if="i==slideCounter")
        div(v-if="c.type=='image'")
          img.image(:src="c.src")
        div(v-if="c.type=='imagesCols'")
          .col(v-for="p in c.pictures" v-bind:class="{s3:c.cols == 4, s4:c.cols == 3}")
            img.image(:src="p")
</template>

<script>

export default {
  data(){
    return {
      project: "",
      slideCounter: 0,
      infoProjects:{
        "BUD LIGTH PARTY": [
          {
            Title: "THE BUD LIGHT PARTY",
            content:[
              {type:"video", url:"https://www.youtube.com/embed/KK720gmxvcE"},
              {type:"video", url:"https://www.youtube.com/embed/-XqcfczdbW0"},
              {type:"video", url:"https://www.youtube.com/embed/bsW5JMoEWtA"},
              {type:"slides", pictures:[
                "/static/works/content/CadaBudLight.png",
                "/static/works/content/CambioElLook.png",
                "/static/works/content/Ciudadano.png",
                "/static/works/content/ElEquipoDelEquipo.png",
                "/static/works/content/ElFuturoEsta.png",
                "/static/works/content/Houston.png",
                "/static/works/content/LAtinosInTheHouse.png",
                "/static/works/content/PorDentroNever.png",
                "/static/works/content/PorLosGigantes.png",
                "/static/works/content/SeVeComoNunca.png",
                "/static/works/content/UnPartyAlQue.png",
                "/static/works/content/VotePorElNuevoBote.png",
                "/static/works/content/VotosBotas.png"
              ]}
            ]
          },
          {
            Title: "BUD LIGHT COPA AMERICA",
            content:[
              {type:"text", text:'The Bud Light Party teamed up with Mexican National Team and International star Javier "Chicharito" Hernandez for Copa America.'},
              {type:"video", url:"https://www.youtube.com/embed/eYauX_PxiVY"},
              {type:"image", src:"/static/works/content/MenosRedCards.png"},
              {type:"imagesCols", cols:4, pictures:[
                "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-1.png",
                "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-2.png",
                "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-3.png",
                "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-5.png",
              ]}
            ]
          }
        ]
      }
    }
  },
  mounted(){
    this.project = this.$route.params.work;
  }
}
</script>

<style lang="sass" scoped>
#Header
  height: calc(100vw / 16 * 3.1)
  background: black
  img
    width: 21vw
.youtube
  width: 90vw
  height: calc(90vw / 9 * 5)
.image
  width: 100%
</style>



// WEBPACK FOOTER //
// src/components/work.vue